import { CART_COMPLETENESS_STATUS } from '../types/build-cart';

export type CartActionLabel = 'build' | 'continue' | 'dispatch';

export const getCartActionLabel = (
  traysLoaded: number,
  traysReserved: number,
  traysRequired: number
): CartActionLabel => {
  const completed = traysLoaded + traysReserved;
  if (completed <= 0) return 'build';
  if (traysRequired > 0 && completed >= traysRequired) return 'dispatch';
  return 'continue';
};

export const isCartActionBlocked = (status: string): boolean =>
  status === CART_COMPLETENESS_STATUS.TRAYS_UNAVAILABLE;
